import type { ActiveOrganizationMembership, Session, User } from '@cmoh/shared'
import { useQuery } from '@tanstack/react-query'
import { useApiQuery } from '@/hooks/use-api'
import { getSession } from '@/lib/auth-client'
import { pinTabOrganization } from '@/lib/tab-organization'

const CURRENT_MEMBERSHIP_QUERY_KEY = ['current-membership'] as const
const ACTIVE_MEMBERSHIP_URL = '/organization/active-membership'

type AuthContext = {
  user: User | null
  session: Session | null
  membership: ActiveOrganizationMembership | null
  isLoading: boolean
  error: unknown
}

export function useAuthContext(): AuthContext {
  const {
    data: session,
    isLoading: isLoadingSession,
    error: errorSession,
  } = useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      const { data } = await getSession()
      pinTabOrganization(data?.session?.activeOrganizationId)
      return data ?? null
    },
  })

  const {
    data: membership,
    isLoading: isLoadingMembership,
    error: errorMembership,
  } = useApiQuery<ActiveOrganizationMembership | null>(
    CURRENT_MEMBERSHIP_QUERY_KEY,
    ACTIVE_MEMBERSHIP_URL,
    undefined,
    { enabled: Boolean(session?.user) },
  )

  return {
    user: session?.user ?? null,
    session: session?.session ?? null,
    membership: membership ?? null,
    isLoading: isLoadingSession || isLoadingMembership,
    error: errorSession || errorMembership,
  }
}
